window._ = require('lodash');
require('bootstrap');
window.$ = window.jQuery  =require('jquery');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

 import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;
//window.Pusher.logToConsole = true;
 window.Echo = new Echo({
     broadcaster: 'pusher',
     key: process.env.MIX_PUSHER_APP_KEY,
     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
     forceTLS: true
 });

var channel = window.Echo.channel('currency');
channel.listen('.event', function(data) {
    let fn = window[data.method];
    if (typeof fn === "function") {
        fn(data.data);
    }
});
